import { pick } from 'lodash';

const PREV_KEY = '__previousProps';

export default function deriveStateFromWatchedProps(props, state, watchedProps = {}) {
    const watchedKeys = Object.keys(watchedProps);
    const hasPrevious = state[PREV_KEY] !== undefined;

    const changedProps = watchedKeys.filter((key) => {
        if (!hasPrevious) return true;

        const previousValue = state[PREV_KEY][key];
        const nextValue = props[key];

        if (nextValue === undefined) return false;
        return previousValue !== nextValue;
    });

    if (changedProps.length === 0) {
        return null;
    }

    const stateWithPreviousProps = {
        [PREV_KEY]: pick(props, watchedKeys),
    };

    const newState = changedProps.reduce((aggregatedState, key) => {
        const getValue = watchedProps[key];
        const isFunction = typeof getValue === 'function';
        return {
            ...aggregatedState,
            [key]: isFunction ? getValue() : props[key],
        };
    }, stateWithPreviousProps);

    return newState;
}
